import { render } from "./Section-6.vue?vue&type=template&id=69d9c9fe&scoped=true"
import script from "./Section-6.vue?vue&type=script&lang=js"
export * from "./Section-6.vue?vue&type=script&lang=js"

import "./Section-6.vue?vue&type=style&index=0&id=69d9c9fe&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d9c9fe"]])

export default __exports__